import { Container, Flex, Tab, TabList, Tabs } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';

import { Section } from '@/components/ui/core/Section/Section';
import { PastEventList } from '@/components/ui/features/events-list/EventListGrid/PastEventList';
import { PastEventSearchInput } from '@/components/ui/features/events-list/PastEventSearch/PastEventSearchInput';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { EventListStatus } from '@/enums/EventListStatus';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const PastConferencesContent: FC = () => {
  const { accessFrom = AccessFrom.Core } = useQueryParams<{ accessFrom: AccessFrom }>({
    accessFrom: StringParam,
  });

  return (
    <Layout accessFrom={accessFrom} navigationVariant={'inverted'}>
      <Container>
        <Section pt={{ base: 6, md: 12, lg: 20 }} pb={{ base: 28, lg: 40 }} variant="dimmed" display="block">
          <Flex
            flexDir={{ base: 'column-reverse', lg: 'row' }}
            justify="between"
            alignItems="center"
            borderBottom="1px solid"
            borderColor="gray.200"
          >
            <Tabs size="lg" index={0} w="full">
              <TabList border="none">
                <NextLink shallow href={`/events-list?status=${EventListStatus.live}&accessFrom=${accessFrom}`}>
                  <Tab mr="8" isDisabled={false}>
                    Past
                  </Tab>
                </NextLink>
              </TabList>
            </Tabs>

            <Flex
              mb={{ base: 4, lg: 0 }}
              maxW={{ base: '352px', md: '512px', lg: '398px' }}
              w="full"
              alignItems="center"
            >
              <PastEventSearchInput />
            </Flex>
          </Flex>
          <PastEventList />
        </Section>
      </Container>
    </Layout>
  );
};
